import * as React from 'react';
import States from 'login-constants/states';
import ContextLink from '../Common/ContextLink';

const promptText =
  'The loan application requires you to provide information that is not necessary to obtain a Loan Estimate. If you do not want to complete the full application, you can still';

const LoanEstimatePrompt = () => (
  <div className="LoanEstimatePrompt">
    <span className="LoanEstimatePrompt-text">
      {promptText}&nbsp;
      <ContextLink to={States.LOAN_ESTIMATE_EXPLANATION} data-it="LoanEstimatePrompt">
        obtain a Loan Estimate
      </ContextLink>
      .
    </span>
  </div>
);

export default LoanEstimatePrompt;
